import { render, staticRenderFns } from "./folder-grid-item.vue?vue&type=template&id=1a3af9c8"
import script from "./folder-grid-item.vue?vue&type=script&lang=js"
export * from "./folder-grid-item.vue?vue&type=script&lang=js"
import style0 from "./folder-grid-item.vue?vue&type=style&index=0&id=1a3af9c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports